export default "__VITE_ASSET__BC3o$_oR__"